import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./home.component').then((c) => c.HomeComponent),
    data: {
      title: 'Crowdfunding India - Ketto is a Crowdfunding Platform based out of India',
      dontLoad: 'vwo',
      page_name: 'home',
      category: 'home',
      lastOrderSkip: true
    }
  }
];
